namespace $ {

	export class $shm_hitalama_project extends $giper_baza_entity.with({

		Project_id: $giper_baza_atom_text,
		Files: $giper_baza_list_link.to( ()=> $shm_hitalama_file ),
		Query_logs: $giper_baza_list_link.to( ()=> $shm_hitalama_project_query_log ),
		Opencode_directory: $giper_baza_atom_text,
		Preview_path: $giper_baza_atom_text,
		Opencode_sessions: $giper_baza_list_str,
		Opencode_session_current: $giper_baza_atom_text,
		Version: $giper_baza_atom_text,
		Version_date: $giper_baza_atom_text,
		Version_changes: $giper_baza_atom_text,
		Version_history: $giper_baza_list_str,
		Draft_note: $giper_baza_atom_text,
		Tasks: $giper_baza_list_link.to( ()=> $shm_hitalama_project_task ),

	}){
		
	}

	export class $shm_hitalama_project_task extends $giper_baza_entity.with({

		Legacy_id: $giper_baza_atom_text,
		Project_id: $giper_baza_atom_text,
		Description: $giper_baza_atom_text,
		Result: $giper_baza_atom_text,
		Run_id: $giper_baza_atom_text,
		Status: $giper_baza_atom_text,
		Creator_id: $giper_baza_atom_text,
		Creator_name: $giper_baza_atom_text,
		Assignee_id: $giper_baza_atom_text,
		Assignee_name: $giper_baza_atom_text,
		Acceptance_criteria: $giper_baza_atom_text,
		Priority: $giper_baza_atom_text,
		Revision: $giper_baza_atom_real,
		Planned_revision: $giper_baza_atom_real,
		Mode: $giper_baza_atom_text,
		Pinned: $giper_baza_atom_bool,
		Archived: $giper_baza_atom_bool,
		Created_at: $giper_baza_atom_real,
		Updated_at: $giper_baza_atom_real,

	}) {}

	export class $shm_hitalama_project_dict extends $giper_baza_dict_to(
		$giper_baza_atom_link.to( ()=> $shm_hitalama_project ),
	) {}

	export class $shm_hitalama_project_query_log extends $giper_baza_entity.with({

		Query: $giper_baza_atom_text,
		Time: $giper_baza_atom_real,

	}){
		
	}

}
